var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManufacturinBillProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5215 21.1363C12.5215 18.6047 13.5476 16.1767 15.374 14.3866C17.2005 12.5965 19.6777 11.5908 22.2607 11.5908C24.8436 11.5908 27.3208 12.5965 29.1473 14.3866C30.9737 16.1767 31.9998 18.6047 31.9998 21.1363C31.9998 23.6679 30.9737 26.0958 29.1473 27.8859C27.3208 29.6761 24.8436 30.6817 22.2607 30.6817C19.6777 30.6817 17.2005 29.6761 15.374 27.8859C13.5476 26.0958 12.5215 23.6679 12.5215 21.1363V21.1363ZM21.7049 25.2217L27.312 18.3515L26.2992 17.5574L21.5179 23.4132L18.1312 20.6475L17.3002 21.625L21.7049 25.223V25.2217Z",
    fill: "url(#paint0_linear_389_7935)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55074 30.1953L10.2827 24.9023L11.4783 26.582L0 35V0L15.6522 10.7674L13.9131 12.5989L2.55074 4.80469V30.1953Z",
    fill: "url(#paint1_linear_389_7935)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_389_7935",
    x1: 22.2607,
    y1: 11.5908,
    x2: 22.2607,
    y2: 30.6817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_389_7935",
    x1: 7.82612,
    y1: 0,
    x2: 7.82612,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturinBillProcess);
export default __webpack_public_path__ + "static/media/Manufacturin_Bill_process.1c632e4045f6dbd3460c580233a5c0db.svg";
export { ForwardRef as ReactComponent };